import styled from "styled-components";
import { useContext } from "react";
import AppContext from "../../App/AppContext";
import IconChevron from "../Icons/IconChevron";
const Button = (props = {}) => {
  const { options: { primary_color = "" } = {} } = useContext(AppContext);

  const {
    type = "",
    onClick = () => {},
    rank = "primary",
    chevron = false,
    disabled = false,
  } = props;
  return (
    <ButtonStyles primary_color={primary_color}>
      <button
        className={`${rank} ${chevron ? "chevron" : ""}`}
        disabled={disabled}
        onClick={onClick}
        type={type}
      >
        {props.children}
        {chevron && (
          <IconChevron fill="#fff" width="18" height="18" rotate="-90" />
        )}
      </button>
    </ButtonStyles>
  );
};

export default Button;

const ButtonStyles = styled.div`
  button {
    color: #fff;
    font-family: inherit;
    padding: 8px 16px;
    border-radius: 4px;
    border: none;
    font-weight: semi-bold;
    font-size: 16px;
    min-width: 80px;
    text-align: center;
    justify-content: center;
    width: fit-content;
    cursor: pointer;
  }
  button.chevron {
    display: flex;
    align-items: center;
  }
  button.primary {
    background: ${(props) =>
      props.primary_color ? props.primary_color : "#e0e0e0"};
  }

  button:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;
